import axios from "axios";
import { toSnakeCase } from "../../_helper";

// Generalized function for fetching wallet history
function fetchWalletHistory(
  actionType,
  searchTerm,
  currentPage,
  sortBy,
  sortDir
) {
  const params = {
    search: searchTerm,
    action_type: actionType,
    page: currentPage,
  };

  if (sortBy) {
    params.sort_by = toSnakeCase(sortBy);
    params.sort_dir = sortDir;
  }
  return axios.get(`/admin/wallet/management/walletTransactions`, {
    params,
  });
}

// Specific functions using the generalized fetchWalletHistory function
export function callFetchWalletHistory(
  actionType,
  searchTerm,
  currentPage,
  sortBy,
  sortDir
) {
  return fetchWalletHistory(
    actionType,
    searchTerm,
    currentPage,
    sortBy,
    sortDir
  );
}
